<template>
  <router-view />
</template>

<script>
export default {
  name: "dealings",
};
</script>